module.exports = __webpack_public_path__ + "images/icon_rendement_white.svg";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/img/general/icon_rendement_white.svg
// module id = 60
// module chunks = 0